import { React, useEffect, useState } from "react";
import { t } from "../../Helper";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { uploadMediaData, deleteData } from "../../services/apiService";

const BusinessLogo = ({ onChange }) => {
  const [businessLogo, setBusinessLogo] = useState("Upload Your Business Logo");
  const [postImage, setPostImage] = useState("");
  const [fileName, setFileName] = useState("");

  const { preferredLanguage, currentLanguage } = useSelector(
    (state) => state.settings
  );

  useEffect(() => {
    (async () => {
      try {
        const fetchedData = await t(
          businessLogo,
          currentLanguage,
          preferredLanguage
        );
        setBusinessLogo(fetchedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [preferredLanguage]);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file != "" || file != null) {
      let isError = mediaValidationCheck(file);
      if (isError) {
        return false;
      }

      const formData = new FormData();
      formData.append("file", file);
      // make a POST request to the File Upload API with the FormData object and Rapid API headers

      try {
        const res = await uploadMediaData(
          "public/api/v1/uploadMedia",
          formData
        );
        if (res.result) {
          let mediaDetails = res.data;
          setPostImage(mediaDetails.imageUrl);
          toast.success("Logo has been uploaded, successfully.");
        } else if (!res.success) {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error("Failed to load data", error);
      }
    }
  };

  const mediaValidationCheck = (file) => {
    let isError = false;
    const fileSize = file.size / 1000;
    const allowedFileSize = ["1 MB"];
    if (fileSize > 1000) {
      toast.error(`File size must be ${allowedFileSize.join(", ")}`);
      isError = true;
    }

    const fileExtension = file.name.split(".").at(-1);
    const allowedFileTypes = ["png", "jpeg", "jpg", "gif"];
    if (!allowedFileTypes.includes(fileExtension)) {
      toast.error(
        `File does not support. Files type must be ${allowedFileTypes.join(
          ", "
        )}`
      );
      isError = true;
    }
    return isError;
  };

  const handleFileDelete = async () => {
    setPostImage("");
    try {
      let mediaFileInfo = postImage.split(".com/");
      const res = await deleteData(
        "public/api/v1/deleteMedia?file=" + mediaFileInfo[1]
      );
      setPostImage("");
      toast.success("Deleted, Successfully.");
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  useEffect(() => {
    onChange(postImage);
  }, [postImage]);

  return (
    <>
      <div className="col-12">
        <label className="form-label section-title">{businessLogo}</label>
        <div className="d-flex align-items-center gap-3">
          <div>
            {postImage === "" ? (
              <img
                id="logoPreview"
                className="logo-preview"
                alt="logo preview"
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='96' height='96'%3E%3Crect width='100%25' height='100%25' fill='%23f5f7fb'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b7c0d6' font-size='12'%3ELogo%3C/text%3E%3C/svg%3E"
              />
            ) : (
              <>
                <img className="logo-preview" src={postImage} /> <br />
                <input
                  type="button"
                  onClick={(e) => handleFileDelete()}
                  style={{ fontSize:"10px", cursor: "pointer", color: "red" }}
                  value="Delete"
                />
              </>
            )}
          </div>
          <div className="flex-fill">
            <input
              type="file"
              id="logoInput"
              label="Image"
              name="myFile"
              accept=".jpeg, .png, .jpg"
              className="form-control mb-2"
              onChange={(e) => handleFileUpload(e)}
            />
            <div className="small-muted">Recommended: PNG or SVG. Max 2MB.</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessLogo;
